import { Typography } from "@mui/material"

export function TailoredScheduleTitle({ payload }) {
    const { scheduleCode, scheduleTitle } = payload

    return (
        <Typography variant="subtitle2">
            {scheduleTitle} <small>#{scheduleCode}</small>
        </Typography>
    )
}
